export function Footer() {
  return (
    <div className="border-t mt-10">
      <div className="grid-auto">
        <div className="col-span-12">
          <p className="type-body-s py-[1em]">Copyright &copy; {new Date().getFullYear()} Carriageworks</p>
        </div>
      </div>
    </div>
  )
}
